/* These slot id's are based on wowheads XML */

enum ItemSlot {
  Any = -2,
  None = -1,
  Ammo = 0,
  Head = 1,
  Neck = 2,
  Shoulder = 3,
  Shirt = 4,
  Chest = 5,
  Waist = 6,
  Legs = 7,
  Feet = 8,
  Wrist = 9,
  Hands = 10,
  Finger = 11,
  Trinket = 12,
  Onehand = 13,
  Ranged = 15,
  Back = 16,
  Twohand = 17,
  Tabard = 19,
  Mainhand = 21,
  Quiver = 20,
  Offhand = 23,
  Projectile = 24,
  Finger2 = 25,
  Trinket2 = 26,
  Relic = 28
}

export default ItemSlot
